<template>
  <div
    class="map"
    style="height: 100%"
    :style="wrapper"
    v-wechat-title="$store.state.region.re_name + '-智能导览地图'"
  >
    <div id="allmap"></div>
    <baidu-map
      ref="map"
      :style="wrapper"
      :center="center"
      :zoom="isZoom"
      id="myMap"
      @ready="handler"
      @zoomend="zoomendChange"
      :max-zoom="maxZoom"
      :mapType="maptype"
      :min-zoom="minZoom"
      ak="R9Z98XEvB0uWLHGRT4YLlrGo0h5Ey9BP"
    >
      <!-- 缩小放大控件 -->
      <bm-navigation
        anchor="BMAP_ANCHOR_TOP_RIGHT"
        :offset="{ width: 10, height: 60 }"
      ></bm-navigation>
      <!-- 定位 -->
      <bm-geolocation
        :offset="{ width: 10, height: 300 }"
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :showAddressBar="true"
        :autoLocation="true"
      ></bm-geolocation>
      <!-- 标记点 -->
      <template v-if="touristSpots.length > 0">
        <div v-for="(item, index) in touristSpots" :key="item.id">
          <bm-label
            v-if="item.DicName.indexOf('拐点') == -1"
            :content="`<div class='merkerText'><img src=${markerIcon} />
            <span>${item.DicName}</spam>
          </div>`"
            :title="item.DicName"
            :position="{ lng: item.Longitude, lat: item.Latitude }"
            :labelStyle="{
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0)',
            }"
            @click="markers(item, index)"
          />
        </div>
      </template>
      <!-- 文本框 -->
      <template v-if="TouristRoute.flag && !checked1">
        <div v-for="(item, index) in lineNavigationList1.item" :key="item.id">
          <bm-label
            v-if="item.DicName.indexOf('拐点') == -1"
            :content="item.DicName"
            :title="item.DicName"
            :position="{ lng: item.Longitude, lat: item.Latitude }"
            :labelStyle="{
              color: '#333',
              fontSize: '14px',
              backgroundColor: 'rgba(255,255,254,.8)',
              borderRadius: '4px',
              padding: '8px',
            }"
            :offset="{ width: -35, height: 6 }"
            @click="markers(item, index)"
          >
          </bm-label>
        </div>
      </template>
      <template v-else-if="checked1">
        <div v-for="(item, index) in lineNavigationList_nav" :key="item.id">
          <bm-label
            v-if="item.DicName.indexOf('拐点') == -1"
            :content="
              '<div class=labelIndex>' + JSON.stringify(index + 1) + '</div>'
            "
            :title="item.DicName"
            :position="{ lng: item.Longitude, lat: item.Latitude }"
            :labelStyle="{
              color: '#333',
              fontSize: '14px',
              backgroundColor: 'rgba(255,255,254,.8)',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0',
            }"
            :offset="{ width: -16, height: -10 }"
            @click="markers1(item, index)"
          >
          </bm-label>
        </div>
      </template>
      <!-- 自定义覆盖物 -->
      <bm-overlay
        v-show="overlayShow"
        pane="labelPane"
        ref="customOverlay"
        :class="{ sample: true, active }"
        @mouseover.native="active = true"
        @mouseleave.native="active = false"
        @draw="draw"
      >
        <div>
          <div class="larbes">
            <span class="h2">{{ overlayDetail.DicName }}</span>
            <img @touchstart="delelt" src="@/assets/images/delelt.png" alt="" />
          </div>
          <div
            class="centers"
            :class="
              overlayDetail.audioSrc != null &&
              overlayDetail.audio_content != null
                ? ''
                : 'flexall'
            "
          >
            <div class="Listeningtovoice">
              <div
                class="Listeningtovoiceclick"
                @touchstart="playAudio1"
                v-show="overlayDetail.audioSrc != null"
              >
                <span>中文</span>
                <img v-show="!isShow1" src="@/assets/images/off.png" alt="" />
                <img v-show="isShow1" src="@/assets/images/no.png" alt="" />
              </div>
              <div
                class="Listeningtovoiceclick"
                @touchstart="playAudio3"
                v-show="overlayDetail.en_audio != null"
              >
                <span>EN</span>
                <img v-show="!isShow3" src="@/assets/images/off.png" alt="" />
                <img v-show="isShow3" src="@/assets/images/no.png" alt="" />
              </div>
              <div
                class="Listeningtovoiceclick"
                @touchstart="playAudio2"
                v-show="overlayDetail.audio_content != null"
              >
                <span>AI</span>
                <img v-show="!isShow2" src="@/assets/images/off.png" alt="" />
                <img v-show="isShow2" src="@/assets/images/no.png" alt="" />
              </div>
            </div>
            <div class="dx">
              <span @touchstart="Navigation">导航</span>
              <span
                @touchstart="detail"
                v-if="
                  overlayDetail.audioSrc != null ||
                  overlayDetail.audio_content != null
                "
                >详情</span
              >
            </div>
          </div>
        </div>
      </bm-overlay>
      <!-- 线路 -->
      <!-- <bm-walking :start="TouristRoute.start" :end="TouristRoute.end" :panel="false" :auto-viewport="true" location="安徽"></bm-walking> -->
      <bm-polyline
        v-if="TouristRoute.flag"
        :path="polylinePath"
        stroke-color="blue"
        :stroke-opacity="0.5"
        :stroke-weight="4"
        :editing="false"
      ></bm-polyline>
      <!-- <bm-driving
        v-if="TouristRoute.flag"
        :start="TouristRoute.start"
        :end="TouristRoute.end"
        policy="BMAP_DRIVING_POLICY_LEAST_DISTANCE"
        :waypoints="TouristRoute.waypoints"
        :panel="false"
      ></bm-driving> -->
      <bm-tile
        v-if="tileUrlTemplate != '' && isShouhui"
        :isTransparentPng="true"
        :tileUrlTemplate="tileUrlTemplate"
      >
      </bm-tile>
    </baidu-map>
    <!-- 右侧手绘地图开关 -->
    <div class="rightSwitch">
      <van-switch v-model="checked" :size="16" @change="switchchange" />
      <span>手绘地图</span>
    </div>
    <div class="rightSwitch" style="top: 36%">
      <van-switch
        v-model="checked1"
        :size="16"
        @change="switchchange1"
        :loading="loadingFlag"
      />
      <span>游览线路</span>
    </div>
    <!-- 左侧楼层列表 -->
    <div
      class="left_center"
      v-if="leftShow && scenicaudios_floorList.length > 0"
    >
      <div style="text-align: center; margin-bottom: 6px">
        <span @click="backLoc">返回</span>
      </div>
      <!-- <p style="font-size: 12px">当前位置:</p>
      <p style="font-size: 12px;max-width:50px;text-align: left;margin:2px 0">水上乐园撒是</p> -->
      <div
        class="left_center_list"
        :class="loucengIndex === index ? 'color_lou' : ''"
        v-for="(item, index) in scenicaudios_floorList"
        :key="item.id"
        @click="louceng(item, index)"
      >
         {{ item.DicName.split("#")[0] }}
      </div>
    </div>
    <!-- 底部导航栏 -->
    <!-- <div class="footerNav" v-show="!isShow">
      <div
        class="footerNavItem"
        :class="footerNavIndex === index ? 'footerNavItem_active' : ''"
        @click="footerNavItemClick(item, index)"
        v-for="(item, index) in service_data"
        :key="index"
      >
        <img :src="item[0].icon" alt="" />
        <span v-if="index == 0 && service_data[0].length > 0 && !item[0].name"
          >游览点</span
        >
        <span v-else>{{ item[0].name }}</span>
      </div>
    </div> -->
    <div v-show="!isShow && service_data.length > 0">
      <div class="footerNav" v-if="service_data.length < 8">
        <div
          class="footerNavItem"
          :class="footerNavIndex === index ? 'footerNavItem_active' : ''"
          @click="footerNavItemClick(item, index)"
          v-for="(item, index) in service_data"
          :key="index"
        >
          <img :src="item[0].icon" alt="" />
          <span v-if="index == 0 && service_data[0].length > 0 && !item[0].name"
            >游览点</span
          >
          <span v-else>{{ item[0].name }}</span>
        </div>
      </div>
      <div class="footerNav" v-else>
        <van-swipe :width="60" :show-indicators="false" :loop="false">
          <van-swipe-item v-for="(item, index) in service_data" :key="index">
            <div
              class="footerNavItem"
              :class="footerNavIndex === index ? 'footerNavItem_active' : ''"
              @click="footerNavItemClick(item, index)"
            >
              <img :src="item[0].icon" alt="" />
              <span
                v-if="index == 0 && service_data[0].length > 0 && !item[0].name"
                >游览点</span
              >
              <span v-else>{{ item[0].name }}</span>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- 底部线路选择 -->
    <div class="footerList" v-if="isShow">
      <div class="footerList_top">
        <van-swipe
          ref="swipers1"
          width="126"
          height="40"
          :loop="false"
          class="my-swipe"
          :show-indicators="false"
        >
          <van-swipe-item
            :class="index === footerList_topIndex1 ? 'sanjiao' : ''"
            style="min-width: 100px"
            @click="footerList_top(index)"
            v-for="(item, index) in lineNavigationList"
            :key="item.routeId"
            :style="index === footerList_topIndex1 ? 'color:#e95b2d' : ''"
          >
            <div class="wap">{{ item.RouteName }}</div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="footerList_bottom">
        <van-swipe
          ref="swipers2"
          width="90"
          :loop="false"
          :show-indicators="false"
        >
          <van-swipe-item
            @click="footerList_top1(item, index)"
            v-for="(item, index) in lineNavigationList_nav"
            :key="item.id"
          >
            <div class="footerList_bottom_list">
              <span
                :style="
                  index === footerList_topIndex2
                    ? 'color:#e95b2d;border: 1px solid #e95b2d;box-shadow: 0 0 4px #e95b2d;'
                    : ''
                "
                >{{ index + 1 }}</span
              >
              <p>{{ item.DicName }}</p>
            </div>
            <div
              class="gang"
              v-if="index != lineNavigationList_nav.length - 1"
            ></div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <audio :src="overlayDetail.audioSrc" id="zhenren"></audio>
  </div>
</template>
<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmView from "vue-baidu-map/components/map/MapView.vue";
import BmScale from "vue-baidu-map/components/controls/Scale";
import BmNavigation from "vue-baidu-map/components/controls/Navigation";
import BmMarkerClusterer from "vue-baidu-map/components/extra/MarkerClusterer";
import BmMarker from "vue-baidu-map/components/overlays/Marker";
import BmLabel from "vue-baidu-map/components/overlays/Label";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow";
import BmBoundary from "vue-baidu-map/components/others/Boundary";
import BmDriving from "vue-baidu-map/components/search/Driving";
import BmTile from "vue-baidu-map/components/layers/Tile";
import BmPolyline from "vue-baidu-map/components/overlays/Polyline";
import BmOverlay from "vue-baidu-map/components/overlays/Overlay";
import BmWalking from "vue-baidu-map/components/search/Walking";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation";
import Footer from "@/components/footer";
import listeningtocVoice from "@/components/travel/listeningtocVoice";
import {
  mapIndex,
  jsapi_ticket,
  scenicaudio,
  lineNavigation,
  serviceFacility,
  scenicaudios_floor,
} from "@/api/travel";
const wx = require("jweixin-module");
import $ from "jquery";
import TtsRecorder from "@/assets/js/speechSynthesis/audio";
const ttsRecorder = new TtsRecorder();
export default {
  components: {
    BaiduMap,
    BmScale,
    BmNavigation,
    BmMarkerClusterer,
    BmMarker,
    BmInfoWindow,
    BmBoundary,
    BmLabel,
    BmDriving,
    BmView,
    BmTile,
    BmPolyline,
    BmOverlay,
    Footer,
    listeningtocVoice,
    BmWalking,
    BmGeolocation,
  },
  data() {
    return {
      show: true,
      active: true,
      checked: false,
      checked1: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow: false,
      loadingFlag: false,
      overlayShow: false,
      overlayDetail: {},
      s1: 0,
      s2: 0,
      footerList_topIndex1: 0,
      footerList_topIndex2: -1,
      footerNavIndex: 0,
      touristSpots: [],
      allTouristSpots: [],
      wxJsSdk: {},
      activeNames: ["0"],
      activeNames1: "0",
      rightList: [
        "游览点",
        "游客中心",
        "停车场",
        "餐饮",
        "住宿",
        "购物店",
        "旅游厕所",
      ],
      maptype: "BMAP_NORMAL_MAP",
      center: { lng: 0, lat: 0 },
      maxZoom: 18,
      minZoom: 6,
      zoom: 10,
      wrapper: {
        width: document.body.clientWidth + "px",
        height: document.body.clientHeight + "px",
      },
      allList: false,
      labelIndex: 2,
      services: [],
      TouristRoutes: [],
      TouristRoute: {
        end: {},
        start: {},
        flag: false,
        waypoints: [],
      },
      Region: {},
      BMap: {},
      map: {},
      tileUrlTemplate: "",
      isShouhui: false,
      sss: { lat: 0, lng: 0 },
      lineNavigationList: [],
      lineNavigationList1: [],
      lineNavigationList_nav: [],
      reset: {},
      service_data: [],
      markerIcon: "",
      setZoom: 8,
      isZoom: 8,
      polylinePath: [],
      loucengIndex: -1,
      leftShow: false,
      scenicaudios_floorList: [],
      oneFlag: true,
    };
  },
  beforeDestroy() {
    this.isShowMusic();
  },
  created() {
    jsapi_ticket({
      jsapiticket_url: location.href.split("#")[0],
    }).then((res) => {
      this.wxJsSdk = res.signPackage;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.wxJsSdk.appId, // 必填，公众号的唯一标识
        timestamp: this.wxJsSdk.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.wxJsSdk.nonceStr, // 必填，生成签名的随机串
        signature: this.wxJsSdk.signature, // 必填，签名
        jsApiList: ["openLocation", "navigateToMiniProgram", "miniProgram"], // 必填，需要使用的JS接口列表
      });
    });
    this.lineNavigations();
    this.serviceFacilityLoding();
    if (!this.$route.params.id) {
      this.$toast.fail("信息不存在");
    }
    this.$toast.loading({
      message: "加载中...",
      forbidClick: true,
    });
    this.$nextTick(() => {
      let audios = $("#zhenren");
      this.element = audios[0];
    });
    this.isflaag();
  },
  watch: {
    //监听sss定位的值，每次重新渲染加载自定义覆盖物，解决地图卡死问题
    sss: {
      handler() {
        this.$refs.customOverlay.reload(); // 当位置发生变化时，重新渲染，内部会调用draw
      },
      deep: true,
    },
  },
  methods: {
    // 百度坐标系转腾讯坐标
    bMapToQQMap(lng, lat) {
      if (lng == null || lng == "" || lat == null || lat == "")
        return [lng, lat];
      var x_pi = 3.14159265358979324;
      var x = parseFloat(lng) - 0.0065;
      var y = parseFloat(lat) - 0.006;
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      var lng = (z * Math.cos(theta)).toFixed(7);
      var lat = (z * Math.sin(theta)).toFixed(7);
      return [lng, lat];
    },
    //关闭所有音乐
    isShowMusic() {
      ttsRecorder.stop();
      this.element.pause();
      this.isShow1 = false;
      this.isShow2 = false;
      this.isShow3 = false;
    },
    playAudio1() {
      let flag = (this.isShow1 = !this.isShow1);
      this.isflaag();
      if (!flag) {
        this.element.pause();
        return;
      }
      this.isShow1 = flag;
      this.element.play();
      this.audioChange();
    },
    playAudio3() {
      let flag = (this.isShow3 = !this.isShow3);
      this.isflaag();
      if (!flag) {
        this.element.pause();
        return;
      }
      this.isShow3 = flag;
      this.element.play();
      this.audioChange();
    },
    playAudio2() {
      let flag = (this.isShow2 = !this.isShow2);
      this.isflaag();
      if (!flag) {
        return;
      }
      setTimeout(() => {
        this.yuyin();
      }, 300);
      this.isShow2 = flag;
    },
    isflaag() {
      if (this.element) {
        this.element.currentTime = 0;
        this.element.pause();
      }
      ttsRecorder.stop();
      this.isShow1 = false;
      this.isShow2 = false;
      this.isShow3 = false;
    },
    //监听语音结束
    audioChange() {
      var that = this;
      this.element.addEventListener(
        "ended",
        function () {
          that.isShow1 = false;
          that.isShow2 = false;
        },
        false
      );
    },
    yuyin() {
      //要合成的文本
      ttsRecorder.setParams({
        text: this.overlayDetail.audio_content,
        speed: 50,
        voice: 50,
      });
      ttsRecorder.start();
    },
    //缩放地图结束时触发
    zoomendChange(e) {
      this.setZoom = e.target.getZoom();
      if (this.allTouristSpots.length > 0) {
        if (this.footerNavIndex == 0 && !this.checked1) {
          //关闭弹窗
          this.delelt();
          this.touristSpots = [];
          //筛选游览点
          if (this.setZoom == this.minZoom) {
            this.allTouristSpots.forEach((v) => {
              if (v.DicName.indexOf("拐点") == -1) {
                if (v.scale_zoom >= 20) {
                  this.touristSpots.push(v);
                }
              }
            });
          } else {
            this.allTouristSpots.forEach((v) => {
              if (v.DicName.indexOf("拐点") == -1) {
                if (v.scale_zoom <= this.setZoom || v.scale_zoom >= 20) {
                  this.touristSpots.push(v);
                }
              }
            });
          }
        }
      }
    },
    //自定义覆盖物
    draw({ el, BMap, map }) {
      const pixel = map.pointToOverlayPixel(
        new BMap.Point(this.sss.lng, this.sss.lat)
      );
      this.isShowIf(el, pixel);
    },
    isShowIf(el, pixel) {
      if (!this.isShow) {
        // console.log('没有语音');
        el.style.left = pixel.x - 62 + "px";
        if (
          this.overlayDetail.audioSrc != null ||
          this.overlayDetail.audio_content != null
        ) {
          el.style.top = pixel.y - 130 + "px";
          el.style.left = pixel.x - 82 + "px";
        } else {
          el.style.top = pixel.y - 94 + "px";
        }
      } else {
        // console.log('有语音');
        //线路自定义覆盖物
        el.style.left = pixel.x - 76 + "px";
        if (
          this.overlayDetail.audioSrc != null ||
          this.overlayDetail.audio_content != null
        ) {
          el.style.left = pixel.x - 96 + "px";
          el.style.top = pixel.y - 140 + "px";
        } else {
          el.style.top = pixel.y - 104 + "px";
        }
      }
    },
    isdeaw() {
      const el = document.getElementsByClassName("sample")[0];
      const pixel = this.map.pointToOverlayPixel(
        new BMap.Point(this.sss.lng, this.sss.lat)
      );
      this.isShowIf(el, pixel);
    },
    goSkinReport() {
      var ua = window.navigator.userAgent.toLowerCase();
      //先判断是否微信浏览器
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //再判断一下是否在小程序里
        wx.miniProgram.getEnv((res) => {
          console.info("res", res);
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url: `/pages/voiceExplanation/voiceExplanation?id=${this.overlayDetail.videoId}`,
            });
          }
        });
      } else {
      }
    },
    //打开内置微信地图
    isWxMap() {
      //百度坐标系转成腾讯坐标系
      const zuobiao = this.bMapToQQMap(
        this.overlayDetail.Longitude,
        this.overlayDetail.Latitude
      );
      wx.ready((res) => {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        wx.openLocation({
          latitude: parseFloat(zuobiao[1]),
          longitude: parseFloat(zuobiao[0]),
          name: this.overlayDetail.DicName,
          success: (res) => {
            console.log("success");
          },
        });
        wx.error(function (res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      });
    },
    //手绘地图开关
    switchchange(e) {
      if (this.Region.isShouhui == 0) {
        this.$toast("该景区暂无手绘地图");
        this.checked = false;
        return;
      }
      this.leftShow = false;
      this.oneFlag = true;
      this.loucengIndex = -1;
      this.sss = this.reset;
      this.overlayShow = false;
      this.isShouhui = !this.isShouhui;
      // this.toMapCenter();
    },
    //游览线路开关
    switchchange1(e) {
      if (this.lineNavigationList.length == 0) {
        this.$toast("暂时没有数据");
        this.checked1 = false;
        return;
      }
      this.leftShow = false;
      this.oneFlag = true;
      this.loucengIndex = -1;
      let timer = null;
      this.isShow = !this.isShow;
      this.overlayShow = false;
      this.loadingFlag = true;
      this.sss = this.reset;
      this.footerList_topIndex2 = -1;
      clearTimeout(timer);
      this.isShowMusic();
      // this.toMapCenter();
      //节流阀，阻止用户连续点击造成地图标记重复问题
      timer = setTimeout(() => {
        this.loadingFlag = false;
      }, 1000);
      if (this.isShow) {
        this.touristSpots = [];
        this.touristRouteList(0);
      } else {
        //重置游览点筛选状态
        if (this.footerNavIndex == 0) {
         if (this.setZoom == this.minZoom) {
            this.allTouristSpots.forEach((v) => {
              if (v.DicName.indexOf("拐点") == -1) {
                if (v.scale_zoom >= 20) {
                  this.touristSpots.push(v);
                }
              }
            });
          } else {
            this.allTouristSpots.forEach((v) => {
              if (v.DicName.indexOf("拐点") == -1) {
                if (v.scale_zoom <= this.setZoom || v.scale_zoom >= 20) {
                  this.touristSpots.push(v);
                }
              }
            });
          }
        } else {
          this.touristSpots = this.service_data[this.footerNavIndex];
        }
        this.TouristRoute.flag = false;
        // this.isZoom = this.minZoom;
      }
    },
    //移动地图位置
    toMapCenter(zoom) {
      var point = new this.BMap.Point(this.sss.lng, this.sss.lat);
      if (zoom != null) {
        this.map.centerAndZoom(point, zoom);
        return;
      }
      this.map.centerAndZoom(point, this.setZoom);
    },
    // 点击左侧楼层
    louceng(item, index) {
      let arr = [item];
      this.loucengIndex = index;
      this.overlayDetail = item;
      // this.markerIcon = item[0].icon;
      this.touristSpots = arr;
      var point = new this.BMap.Point(item.Longitude, item.Latitude);
      this.map.centerAndZoom(point, this.minZoom);
      this.oneFlag = false;
    },
    //点击返回复原
    backLoc() {
      this.footerNavItemClick(
        this.service_data[this.footerNavIndex],
        this.footerNavIndex
      );
      this.leftShow = false;
      this.oneFlag = true;
      this.loucengIndex = -1;
    },
    //点击标记点
    markers(item, index) {
      this.overlayShow = true;
      this.overlayDetail = item;
      this.sss = {
        lng: item.Longitude,
        lat: item.Latitude,
      };
      if (this.footerNavIndex == 0 && this.oneFlag) {
        scenicaudios_floor({ pid: item.id }).then((res) => {
          this.scenicaudios_floorList = res.data;
          this.leftShow = true;
        });
      }
      const el = document.getElementsByClassName("sample")[0];
      this.toMapCenter(null);
      this.isShowMusic();
      if (el != null) {
        this.isdeaw();
      }
    },
    //点击标记点
    markers1(item, index) {
      this.overlayShow = true;
      this.overlayDetail = item;
      this.sss = {
        lng: item.Longitude,
        lat: item.Latitude,
      };
      const el = document.getElementsByClassName("sample")[0];
      this.toMapCenter(null);
      this.isShowMusic();
      if (el != null) {
        this.isdeaw();
      }
    },
    //关闭自定义覆盖物
    delelt() {
      this.overlayShow = false;
      this.isShowMusic();
    },
    //导航
    Navigation() {
      this.isWxMap();
    },
    //详情
    detail() {
      this.goSkinReport();
    },
    iscenter(e) {
      var point = new this.BMap.Point(e.Longitude, e.Latitude);
      this.map.centerAndZoom(point, this.minZoom);
    },
    //底部标题点击事件
    footerList_top(index) {
      this.lineNavigationList_nav = [];
      this.lineNavigationList1 = this.lineNavigationList[index];
      this.iscenter({
        Longitude: this.lineNavigationList1.item[0].Longitude,
        Latitude: this.lineNavigationList1.item[0].Latitude,
      });
      this.lineNavigationList1.item.forEach((v) => {
        if (v.DicName.indexOf("拐点") == -1)
          this.lineNavigationList_nav.push(v);
      });

      this.footerList_topIndex1 = index;
      this.footerList_topIndex2 = -1;
      this.center = this.reset;
      this.overlayShow = false;
      this.touristRouteList(0);
      this.isShowMusic();
      if (index > 1 && this.s1 < index) {
        this.$refs.swipers1.next();
      } else {
        this.$refs.swipers1.prev();
      }

      this.s1 = index;
    },
    footerList_top1(item, index) {
      this.overlayShow = true;
      this.overlayDetail = item;
      this.iscenter({ Longitude: item.Longitude, Latitude: item.Latitude });
      this.sss = {
        lng: item.Longitude,
        lat: item.Latitude,
      };
      this.isShowMusic();
      const el = document.getElementsByClassName("sample")[0];
      if (el != null) {
        this.isdeaw();
      }
      this.footerList_topIndex2 = index;
      if (index > 1 && this.s2 < index) {
        this.$refs.swipers2.next();
      } else {
        this.$refs.swipers2.prev();
      }
      this.s2 = index;
    },
    //底部导航栏事件
    footerNavItemClick(item, index) {
      this.footerNavIndex = index;
      this.overlayShow = false;
      this.sss = this.center;
      // this.setZoom = this.isZoom;
      this.leftShow = false;
      this.oneFlag = true;
      this.loucengIndex = -1;
      this.toMapCenter(this.minZoom);
      this.isShowMusic();
      setTimeout(() => {
        this.markerIcon = item[0].icon;
        this.touristSpots = [];
        if (this.footerNavIndex == 0) {
          if (this.setZoom == this.minZoom) {
            item.forEach((v) => {
              if (v.DicName.indexOf("拐点") == -1) {
                if (v.scale_zoom >= 20) {
                  this.touristSpots.push(v);
                }
              }
            });
          } else {
            item.forEach((v) => {
              if (v.DicName.indexOf("拐点") == -1) {
                if (v.scale_zoom <= this.setZoom || v.scale_zoom >= 20) {
                  this.touristSpots.push(v);
                }
              }
            });
          }
        } else {
          this.touristSpots = item;
        }
      }, 300);
    },

    // 地图加载事件
    handler({ BMap, map }) {
      this.map = map;
      this.BMap = BMap;
      mapIndex(this.$route.params).then((res) => {
        this.center.lng = res.Region.Longitude;
        this.center.lat = res.Region.Latitude;
        this.reset = {
          lng: res.Region.Longitude,
          lat: res.Region.Latitude,
        };
        this.maxZoom = res.Region.MaxScale;
        this.minZoom = res.Region.MinScale;
        this.allList = res.list;
        this.services = res.services;
        this.TouristRoutes = res.TouristRoutes;
        this.Region = res.Region;
        if (this.Region.isShouhui == 1) {
          this.checked = true;
        }
        this.$store.commit("SET_RGION", this.Region);
        this.randerAreaData();
        this.sss = {
          lng: res.Region.Longitude,
          lat: res.Region.Latitude,
        };
        //手绘地图
        this.$route.meta.title =
          "云游库-" + res.Region.RegionName + "全域电子地图";
        if (this.Region.isShouhui == 1) {
          this.isShouhui = this.Region.isShouhui;
          this.tileUrlTemplate =
            "https://yuyok.oss-cn-hangzhou.aliyuncs.com/maps/" +
            this.$route.params.id +
            "/tiles/{Z}/{X}_{Y}.png";
        }
        this.$toast.clear();
      });
    },
    randerAreaData() {
      scenicaudio({ id: this.$route.params.id }).then((res) => {
        if (res.data.length > 0) {
          this.markerIcon = res.icon;
          window.setTimeout(() => {
            this.allTouristSpots = res.data;
            this.allTouristSpots.forEach((v) => {
              if (v.DicName.indexOf("拐点") == -1) {
                if (v.scale_zoom >= 20) {
                  this.touristSpots.push(v);
                }
              }
            });
          }, 300);
          this.service_data.unshift(res.data);
          this.service_data[0][0].icon = res.icon;
        }
      });
    },
    //线路导航
    lineNavigations() {
      this.lineNavigationList_nav = [];
      lineNavigation({ id: this.$route.params.id }).then((res) => {
        this.lineNavigationList = res.result;
        this.lineNavigationList1 = this.lineNavigationList[0];
        this.lineNavigationList1.item.forEach((v) => {
          if (v.DicName.indexOf("拐点") == -1)
            this.lineNavigationList_nav.push(v);
        });
      });
    },
    //处理线路导航数据
    touristRouteList(index) {
      window.setTimeout(() => {
        this.TouristRoute.flag = true;
        this.TouristRoute.waypoints = [];
        this.polylinePath = [];
        this.TouristRoute.start = {
          lng: parseFloat(this.lineNavigationList1.item[index].Longitude),
          lat: parseFloat(this.lineNavigationList1.item[index].Latitude),
        };
        this.TouristRoute.end = {
          lng: parseFloat(
            this.lineNavigationList1.item[
              this.lineNavigationList1.item.length - 1
            ].Longitude
          ),
          lat: parseFloat(
            this.lineNavigationList1.item[
              this.lineNavigationList1.item.length - 1
            ].Latitude
          ),
        };
        this.lineNavigationList1.item.map((v, i) => {
          if (i != 0 && i < this.lineNavigationList1.item.length - 1)
            this.TouristRoute.waypoints.push({
              lng: parseFloat(v.Longitude),
              lat: parseFloat(v.Latitude),
            });
          this.polylinePath.push({
            lng: parseFloat(v.Longitude),
            lat: parseFloat(v.Latitude),
          });
        });
        this.polylinePath.unshift(this.TouristRoute.start);
        this.polylinePath.push(this.TouristRoute.end);
      }, 300);
    },
    //服务设施
    serviceFacilityLoding() {
      serviceFacility({ id: this.$route.params.id }).then((res) => {
         var service_result = res.service_result
        res.service_data.forEach((v) => {
          this.service_data.push(service_result[v.id]);
        });
      });
    },
  },
};
</script>
<style src="@/assets/css/map.css">
/* <style scoped> */
.van-icon__image {
  width: 2rem;
}
.wrapper {
  height: 100%;
}
</style>
<style>
.labelIndex {
  width: 30px;
  height: 30px;
  border: 2px solid rgb(233, 91, 45);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(233, 91, 45);
  font-weight: bold;
  position: relative;
}
.map .van-grid {
  justify-content: center;
}
.actived {
  background-color: rgb(234, 1, 1) !important;
}
.BMapLabel::after {
  content: "";
  border: none !important;
}
.van-cell__left-icon {
  display: flex;
  align-items: center;
}
.van-cell__left-icon img {
  width: 20px;
  height: 20px;
}
.BMapLabel {
  border: none !important;
}
.yuyincolor .van-grid-item__text {
  color: #e95b2d;
}
.rightList .van-collapse-item__content {
  padding: 0;
}
.markers {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
}
.labels {
  width: auto !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(233, 91, 45);
  color: #fff;
  border-radius: 4px;
  padding: 4px 4px;
  height: auto !important;
}
.merkerText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #333;
  background-color: none !important;
  position: relative;
}
.merkerText img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
}
.merkerText span {
  position: absolute;
  margin-top: 6px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  padding: 2px 6px;
  bottom: -6px;
  transform: translateY(100%);
}
/* .BMap_stdMpCtrl {
  inset: auto 10px 30% auto !important;
} */
</style>
<style scoped>
.sample {
  min-width: 150px;
  min-height: 60px;
  background-color: #fff;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  position: absolute;
  border-radius: 4px;
}
.sample::after {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  bottom: 0;
  transform: translateY(100%);
  left: 46%;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #fff;
}
.sample h2 {
  display: block;
  border-bottom: 1px solid rgb(212, 212, 212);
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  position: relative;
}
.sample h2 img {
  width: 12px;
  height: 12px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}
.active {
  border: none !important;
}

.sample .centers {
  display: flex;
  flex-direction: column;
  padding: 10px;
  padding-top: 4px;
}
.sample .centers .dx {
  display: flex;
  justify-content: center;
}
.sample .centers .dx span {
  color: #fff;
  background-color: #38e299;
  border-radius: 4px;
  width: 85px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  margin-right: 8px;
}

.sample .centers .dx span:last-child {
  margin-bottom: 0;
  background-color: #71bcfe;
  margin-right: 0px;
}
/* .sample .centers {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.sample .centers .dx {
  display: flex;
  flex-direction: column;
}
.sample .centers .dx span {
  color: #fff;
  background-color: #38e299;
  border-radius: 4px;
  width: 66px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 6px;
  font-size: 14px;
}

.sample .centers .dx span:last-child {
  margin-bottom: 0;
  background-color: #71bcfe;
} */
/*底部线路样式*/
.footerList {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  height: 130px;
  left: 0;
  right: 0;
  z-index: 99;
}
/*三角*/
.sanjiao::after {
  content: "";
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid rgb(233, 91, 45);
  position: absolute;
  bottom: 0px;
}
.footerList .footerList_top {
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.1);
}
.footerList .footerList_top .wap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.footerList .footerList_top .van-swipe-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a3a3a3;
}
.footerList_bottom {
  margin-top: 14px;
}
.gang {
  position: absolute;
  width: 30px;
  height: 0px;
  right: 0;
  transform: translateX(50%);
  border-top: 1px solid #a0a0a0;
  margin-bottom: 22%;
}
.footerList_bottom .van-swipe-item {
  display: flex;
  align-items: center;
  padding: 0 6px;
}
.footerList_bottom_list {
  max-width: 90px;
  min-width: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.footerList_bottom span {
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: block;
  border: 1px solid #a0a0a0;
  text-align: center;
  line-height: 34px;
  font-weight: bold;
  color: #a0a0a0;
  box-shadow: 0 0 4px #a0a0a0;
}
.footerList_bottom p {
  width: 100%;
  color: #a0a0a0;
  font-size: 12px;
  margin-top: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
/*底部导航栏*/
.footerNav {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  padding: 6px 2px;
  max-height: 70px;
}
.footerNav .footerNavItem {
  display: flex;
  align-items: center;
  font-size: 12px;
  flex-direction: column;
  color: #333;
  flex: 1;
}
.footerNav .footerNavItem img {
  width: 30px;
  height: 30px;
  margin-bottom: 2px;
}
.footerNav .footerNavItem_active {
  position: relative;
  color: #e95b2d;
}
.footerNavItem_active::before {
  content: "";
  position: absolute;
  bottom: -6%;
  right: 6%;
  left: 6%;
  border-bottom: 2px solid #e95b2d;
}
/*语音样式*/
.sample .Listeningtovoice {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.sample .Listeningtovoice .Listeningtovoiceclick {
  width: 48%;
  height: 30px;
  background: #e95b2d;
  border-radius: 6px;
  color: #fff;
  padding: 0 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  margin-top: 4px;
}
.sample .Listeningtovoice .Listeningtovoiceclick:last-child {
  margin-right: 0;
}
.sample .Listeningtovoice .Listeningtovoiceclick img {
  width: 20px;
  height: 20px;
  margin-left: 2px;
}
/* 地图样式 */
.weixing {
  position: absolute;
  right: 0;
  top: 50%;
  z-index: 9999;
}
.logoTop {
  display: flex;
  align-items: center;
  background-color: rgba(233, 91, 45);
  overflow: hidden;
  justify-content: center;
  height: 44px;
  box-sizing: border-box;
}
.logoTop img {
  width: 56px;
  margin-right: 2px;
}
.logoTop p {
  color: #fff;
  font-size: 24px;
  letter-spacing: 2px;
}
.rightList {
  position: fixed;
  right: 0;
  top: 30%;
  z-index: 99;
  height: 400px;
  overflow-y: scroll;
}
.rightList .rightListItem {
  display: flex;
  flex-direction: column;
  padding: 0 10px;
}
.rightList .rightListItem span {
  padding: 10px 0;
  color: #333;
  border-bottom: 1px solid #cecece;
  font-size: 12px;
  width: 150px;
}
.rightSwitch {
  position: fixed;
  right: 0;
  top: 28%;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  padding: 2px;
}
.rightSwitch span {
  font-size: 12px;
  margin-top: 2px;
}
.flexall {
  justify-content: center !important;
}
.larbes {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 6px;
  border-bottom: 1px solid rgb(212, 212, 212);
  position: relative;
}
.larbes .h2 {
  width: 100%;
  font-size: 14px;
  display: block;
  text-align: center;
  color: #333;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.larbes img {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 4px;
}
.left_center {
  position: fixed;
  left: 0;
  bottom: 33%;
  background: #fff;
  padding: 10px 0;
  overflow-y: scroll;
  height: 200px;
  text-align: center;
}
.left_center_list {
  padding: 6px 12px;
}
.color_lou {
  background: #e95b2d;
  color: #fff;
}
</style>